import React from 'react'
import { useLocation } from 'react-router-dom'
import PageContainer from 'balkerne-components/Container'
import LoadForm from '../components/general/LoadForm'
import { Logout } from '../components/Logout'
import Header from '../components/Header'
import { connect } from 'react-redux'

const LoadFormPage = (...props) => {
  const location = useLocation()
  //console.log(location.state.formId)
  return (
    <>
      <Header
        user_permissions={props[0].userData.data.permissions}
        user_portfolio_type={props[0].userData.data.portfolio_type}
        organisation={props[0].userData.data.orgid}
        customstyle={props[0].userData.data.customstyle}
        logout={() => Logout(props[0])}
      />
      <PageContainer>
        <PageContainer.Center>
          <LoadForm {...location.state} />
        </PageContainer.Center>
      </PageContainer>
    </>
  )
}

function mapStateToProps(state) {
  //console.log(state);
  const { userData, dashboardData } = state

  return {
    dashboardData,
    userData,
  }
}
export default connect(mapStateToProps)(LoadFormPage)
